import { createFileRoute } from '@tanstack/react-router'
import { Homepage } from '../components/pages/Homepage'
import { publicPageHead } from '../lib/seo'

export const Route = createFileRoute('/')({
  component: HomeComponent,
  head: () => publicPageHead({
    title: 'Autoglow Detailing | Ceramic Coating & Paint Correction Bellarine & Geelong',
    description:
      'Premium GYEON ceramic coating and paint correction from a dedicated Drysdale studio, serving the Bellarine Peninsula and Geelong. Tailored detailing after inspection.',
    path: '/',
    ogDescription: 'GYEON ceramic coatings and paint correction from Autoglow in Drysdale, Geelong.',
  }),
})

function HomeComponent() {
  return <Homepage />
}
